import React from 'react'

export const ArrowRight = props => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M11 8.00003C11 7.8046 10.934 7.61003 10.8011 7.45145L6.51522 2.3085C6.21263 1.94506 5.67175 1.89535 5.3083 2.19878C4.94486 2.50136 4.896 3.04137 5.19773 3.40566L9.03534 8.00946L5.33659 12.6055C5.04001 12.9741 5.09829 13.5141 5.46688 13.8107C5.83547 14.1073 6.37464 14.049 6.67208 13.6804L10.8106 8.53747C10.9366 8.38061 11 8.19032 11 8.00003Z'
    />
    <rect
      opacity='0.01'
      y='16'
      width='16'
      height='16'
      transform='rotate(-90 0 16)'
    />
  </svg>
)
